import { ReturnToSchema } from '@gestion-permisos/contracts';

const LOGIN_PATH = '/api/v1/auth/login';

/**
 * Ruta relativa a la que volver después de iniciar sesión, o `/` si no es válida. Solo se aceptan rutas de
 * la propia aplicación (`/…`): se rechazan URL absolutas, `//host`, `/\host`, esquemas como `javascript:`
 * y caracteres de control, con el mismo esquema que valida la API (`ReturnToSchema`).
 */
export function safeReturnTo(candidate: string | null | undefined): string {
  return candidate !== null && candidate !== undefined && ReturnToSchema.safeParse(candidate).success ? candidate : '/';
}

/**
 * Ruta actual para volver después de iniciar sesión: ruta, query y **fragmento**. El fragmento conserva el
 * código del enlace de aprobación del correo (`#codigo=…`, D-13) si la persona aún no tenía sesión; el BFF
 * no lo registra en sus logs (solo la ruta) y lo devuelve en la redirección final.
 */
export function pathOf(location: { pathname: string; search: string; hash: string }): string {
  return `${location.pathname}${location.search}${location.hash}`;
}

/** URL relativa del inicio de sesión del BFF. Se abre con una navegación de página completa. */
export function loginUrl(returnTo: string | null | undefined): string {
  return `${LOGIN_PATH}?returnTo=${encodeURIComponent(safeReturnTo(returnTo))}`;
}
